import Actions                  from 'Redux/Actions';
import { UserTicketRepository } from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from, EMPTY }          from 'rxjs';
import { mergeMap }             from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';

export const downloadUserTicketPdfEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.downloadUserTicketPdfRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        UserTicketRepository.downloadTicketPdf(id)
          .then(() => {
            return Actions.downloadUserTicketPdfSuccess();
          })
          .catch((error: any) => Actions.downloadUserTicketPdfFailure({ error })),
      );
    }),
  );
};
